import vue from 'vue';
import store from '../../../store';

export default vue.extend({
  name: 'ColCopyWidget',
  functional: true,
  props: {
    defaultLayoutColIdx: {
      excluded: true,
      type: Number,
      default: 0,
    },
    colIndex: {
      type: Number,
      default: -1,
      label: 'Specific col index',
      description: 'Specify which col you want to copy from default layout if -1 copy the col in which the widget is, first col is 0',
    },
    layoutName: {
      type: String,
      default: '',
      label: 'Specific layout name',
      description: 'Specific layout name,if empty select default layout',
    },
  },
  render(h, { props }) {
    const idx = props.colIndex > -1 ? props.colIndex : props.defaultLayoutColIdx;
    const col = props.layoutName ? store.getters.getLayoutByNameCol(props.layoutName, idx) : store.getters.getDefaultLayoutCol(idx);
    if (!col) {
      return;
    }
    return col.widgets.map(widget => {
      const Comp = widget.compiledProps.is;
      return (
        <div class="bto-base-widget" id={`widget-${widget.id}`} key={`widget-${idx}-${widget.id}`}>
          <Comp
            props={widget.compiledProps}>
          </Comp>
        </div>
      );
    });
  }
});